@if ((statisticData() ?? {} | keys).length > 0) {
  <div class="icon-list d-flex">
    @for (stat of statisticData() ?? {} | values; track $index) {
      <div
        class="statistic-data-icon"
        [ngClass]="{ 'cursor-pointer': !disabled() }"
        [matTooltip]="stat.resourceId | apmTranslate"
        (click)="onStatisticClick()"
      >
        <fa-icon [icon]="stat.icon"></fa-icon>
      </div>
    }
  </div>
}
